// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  OrientationVersion,
  CohortAssignmentStatus,
} from "./types";


export default __t.row({
  cohortAssignmentId: __t.u64().primaryKey().name("cohort_assignment_id"),
  cohortId: __t.u64().name("cohort_id"),
  orientationId: __t.string().name("orientation_id"),
  get orientationVersion() {
    return OrientationVersion.name("orientation_version");
  },
  get status() {
    return CohortAssignmentStatus;
  },
  assignedByEmail: __t.string().name("assigned_by_email"),
  assignedAt: __t.timestamp().name("assigned_at"),
  cancelledAt: __t.option(__t.timestamp()).name("cancelled_at"),
  cancelledBy: __t.option(__t.string()).name("cancelled_by"),
});
